// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiAccueil.js
//  WikiAccueil
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { useIsMobile } from "../../socle/hooks";   // IMPORT_MOBILE_FAVORIS
import { THEME } from "../../socle/theme";
import { wCat, wRayon } from "./constantes";   // RAYONS_IMPORT
import { ouvrirModule } from "./navigation";   // IMPORT_OUVRIR_MODULE
import { wAcc, wBtnSm, wGhostSm, wInp, wLbl, wPanel, wPur } from "./styles";

// ═══════════════ Accueil ═══════════════
export function WikiAccueil({ api, onOuvrir, onCategorie, onNouvelle, onCorbeille, droits }) {
  const isMobile = useIsMobile();
  const [arbre, setArbre] = useState(null);
  const [mode, setMode] = useState("search");
  const [q, setQ] = useState("");
  const [resultats, setResultats] = useState(null);
  const [question, setQuestion] = useState("");
  const [reponse, setReponse] = useState(null);
  const [charge, setCharge] = useState(false);
  const [erreur, setErreur] = useState("");

  useEffect(() => { api.arbre().then(setArbre).catch((e) => setErreur(e.message)); }, [api]);

  const chercher = async () => {
    if (q.trim().length < 2) return;
    setCharge(true); setReponse(null);
    try { setResultats(await api.chercher(q.trim())); } catch (e) { setErreur(e.message); }
    setCharge(false);
  };
  const demander = async () => {
    if (question.trim().length < 3) return;
    setCharge(true); setResultats(null); setErreur("");
    try { setReponse(await api.demander(question.trim())); } catch (e) { setErreur(e.message); }
    setCharge(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 240 }}>
          <h2 style={{ color: THEME.text, fontSize: 20, fontWeight: 800, margin: 0 }}>📚 Wiki Staff</h2>
          <div style={{ color: THEME.textMuted, fontSize: 13, marginTop: 4 }}>
            La mémoire de l'équipe : procédures, fiches techniques, lore validé, onboarding.
          </div>
        </div>
        {droits.redacteur && <button onClick={onCorbeille} style={wGhostSm}>🗑️ Corbeille</button>}
        {droits.creer && <button onClick={onNouvelle} style={wPur}>+ Nouvelle page</button>}
      </div>

      {/* Recherche / Demander */}
      <div style={wPanel}>
        <div style={{ display: "flex", gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
          {[["search", "🔍 Recherche"], ["ask", "🤖 Demander au wiki"]].map(([id, lbl]) => (
            <button key={id} onClick={() => setMode(id)}
              style={{ ...wBtnSm(mode === id ? (id === "ask" ? THEME.purpleDim : THEME.accentDim) : "transparent",
                                 mode === id ? (id === "ask" ? THEME.purple : THEME.accent) : THEME.border,
                                 mode === id ? (id === "ask" ? THEME.purple : THEME.accent) : THEME.textMuted) }}>
              {lbl}
            </button>
          ))}
        </div>

        {mode === "search" ? (
          <div style={{ display: "flex", gap: 8 }}>
            <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && chercher()}
              placeholder="Rechercher dans le wiki (titre, contenu, tags)…" style={wInp} />
            <button onClick={chercher} disabled={charge} style={{ ...wAcc, whiteSpace: "nowrap" }}>{charge ? "…" : "Chercher"}</button>
          </div>
        ) : (
          <div style={{ display: "flex", gap: 8 }}>
            <input value={question} onChange={(e) => setQuestion(e.target.value)} onKeyDown={(e) => e.key === "Enter" && demander()}
              placeholder="ex : qui valide un remboursement et sous quelles conditions ?" style={wInp} />
            <button onClick={demander} disabled={charge} style={{ ...wPur, whiteSpace: "nowrap" }}>{charge ? "⏳ …" : "Demander"}</button>
          </div>
        )}

        {erreur && <div style={{ color: THEME.red, fontSize: 12.5, marginTop: 10 }}>{erreur}</div>}

        {/* Réponse IA */}
        {reponse && (
          /* CADRE_HORS_NIVEAU — ambre quand ce n'est pas ton rôle : ce
             n'est pas une réponse, c'est un aiguillage. */
          <div style={{ marginTop: 14, borderRadius: 10, padding: 14,
            background: reponse.hors_niveau ? THEME.amberDim : THEME.purpleDim,
            border: `1px solid ${reponse.hors_niveau ? THEME.amber : THEME.purple}` }}>
            {reponse.aucune ? (
              <>
                {/* BOUTON_AIGUILLAGE — le texte dit où aller, le bouton y va. */}
                <div style={{ color: THEME.text, fontSize: 13.5, lineHeight: 1.6, whiteSpace: "pre-wrap" }}>
                  {reponse.suggestion}
                </div>
                {reponse.action && (
                  <button onClick={() => ouvrirModule(reponse.action.module)}
                    style={{ ...wBtnSm(THEME.amberDim, THEME.amber, THEME.amber), marginTop: 12 }}>
                    {reponse.action.libelle}
                  </button>
                )}
              </>
            ) : (
              <>
                <div style={{ color: THEME.purple, fontSize: 11, fontWeight: 700, marginBottom: 8 }}>
                  🤖 RÉPONSE — d'après {reponse.sources.length} page{reponse.sources.length > 1 ? "s" : ""} du wiki
                </div>
                <div style={{ color: THEME.text, fontSize: 13.5, lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{reponse.reponse}</div>
                <div style={{ marginTop: 10, display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {reponse.sources.map((s) => (
                    <button key={s.slug} onClick={() => onOuvrir(s.slug)}
                      style={wBtnSm(wCat(s.categorie).fond, wCat(s.categorie).couleur, wCat(s.categorie).couleur)}>
                      [{s.index}] 📚 {s.titre}
                    </button>
                  ))}
                </div>
              </>
            )}
            {/* PIED_SOURCES — cette phrase ne veut rien dire quand aucune
                page n'a été lue. */}
            {!reponse.aucune && (
              <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 10 }}>
                Réponse générée à partir des pages ci-dessus — vérifie la source avant d'agir.
              </div>
            )}
          </div>
        )}

        {/* Résultats de recherche */}
        {resultats && (
          <div style={{ marginTop: 14 }}>
            <div style={{ ...wLbl, marginBottom: 8 }}>{resultats.length} résultat{resultats.length > 1 ? "s" : ""}</div>
            {resultats.length === 0 && <div style={{ color: THEME.textDim, fontSize: 13 }}>Aucune page ne correspond.</div>}
            {resultats.map((r) => (
              <div key={r.id} onClick={() => onOuvrir(r.slug)}
                style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", marginBottom: 8, cursor: "pointer" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  <span style={{ color: THEME.text, fontWeight: 700, fontSize: 13.5 }}>{r.titre}</span>
                  <Badge text={wCat(r.categorie).label} bg={wCat(r.categorie).fond} color={wCat(r.categorie).couleur} />
                  {r.statut === "brouillon" && <Badge text="brouillon" bg={THEME.amberDim} color={THEME.amber} />}
                </div>
                <div style={{ color: THEME.textMuted, fontSize: 12.5, marginTop: 4 }}>{r.extrait}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* BANDE_EPINGLEES — « commence par là », en haut, et rien du tout
          quand rien n'est épinglé. */}
      {arbre && arbre.epinglees.length > 0 && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={wLbl}>📌 Commence par là</span>
          {/* BANDE_RESTE_A_LIRE — le serveur n'envoie plus que le non-lu.
              Plus de gris ni de ✓ à afficher : ce qui est lu n'est plus là,
              et quand il ne reste rien la bande entière disparaît. */}
          {arbre.epinglees.map((p) => (
            <button key={p.id} onClick={() => onOuvrir(p.slug)}
              title="Pas encore lue — ouvre-la et clique « ✓ J'ai lu »"
              style={wBtnSm(wCat(p.categorie).fond, wCat(p.categorie).couleur, wCat(p.categorie).couleur)}>
              {p.verrouille ? "🔒 " : ""}{wCat(p.categorie).icone} {p.titre}
            </button>
          ))}
        </div>
      )}

      {!arbre && !erreur && <div style={{ color: THEME.textMuted }}>Chargement…</div>}

      {arbre && (
        <>
          {/* COLONNE_FAVORIS — les rayons à gauche, tes favoris à droite.
              Sur mobile la colonne passe dessous : à 360 px de large, deux
              colonnes ne sont pas deux colonnes, ce sont deux moitiés
              illisibles. */}
          <div style={{ display: "grid", gap: 16, alignItems: "start",
                        gridTemplateColumns: isMobile ? "1fr" : "minmax(0, 1fr) 280px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {/* GRILLE_RAYONS — deux niveaux : le rayon, puis ses sous-rayons.
              Chacun affiche sa description : c'est elle qui dit ce qu'on
              range là, et donc où aller chercher. */}
          {Object.entries(
            arbre.categories.reduce((acc, c) => {
              const r = wCat(c.cle).rayon;
              (acc[r] = acc[r] || []).push(c);
              return acc;
            }, {})
          ).map(([cleRayon, cats]) => {
            const R = wRayon(cleRayon);
            const total = cats.reduce((n, c) => n + Number(c.total || 0), 0);
            return (
              <div key={cleRayon} style={{ marginBottom: 6 }}>
                <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 4 }}>
                  <span style={{ fontSize: 20 }}>{R.icone}</span>
                  <span style={{ color: R.couleur, fontSize: 16, fontWeight: 800 }}>{R.label}</span>
                  <span style={{ color: THEME.textDim, fontSize: 11 }}>
                    {total} fiche{total > 1 ? "s" : ""}
                  </span>
                </div>
                <div style={{ color: THEME.textMuted, fontSize: 12.5, marginBottom: 10, lineHeight: 1.5 }}>
                  {R.description}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 12 }}>
                  {cats.map((c) => {
                    const st = wCat(c.cle);
                    return (
                      <button key={c.cle} onClick={() => onCategorie(c.cle)}
                        onMouseEnter={(e) => (e.currentTarget.style.borderColor = st.couleur)}
                        onMouseLeave={(e) => (e.currentTarget.style.borderColor = THEME.border)}
                        style={{ ...wPanel, textAlign: "left", cursor: "pointer", fontFamily: "inherit" }}>
                        <div style={{ color: st.couleur, fontSize: 14, fontWeight: 700 }}>{st.label}</div>
                        <div style={{ color: THEME.textMuted, fontSize: 12, marginTop: 6, lineHeight: 1.45 }}>
                          {st.description}
                        </div>
                        <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 10 }}>
                          {c.total} fiche{c.total > 1 ? "s" : ""}
                          {c.derniere ? ` · modifiée le ${new Date(c.derniere).toLocaleDateString("fr")}` : ""}
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
          </div>

          {/* FIN_COLONNE_FAVORIS — la colonne de droite. Vide, elle explique
              comment la remplir : une colonne vide sans mode d'emploi, on la
              regarde une fois et plus jamais. */}
          <div style={{ ...wPanel, position: isMobile ? "static" : "sticky", top: 14 }}>
            <div style={{ ...wLbl, marginBottom: 10 }}>⭐ Mes favoris</div>
            {(!arbre.favoris || arbre.favoris.length === 0) ? (
              <div style={{ color: THEME.textDim, fontSize: 12.5, lineHeight: 1.55 }}>
                Aucun pour l'instant. Ouvre une fiche et clique sur l'étoile
                en haut : elle apparaîtra ici, pour toi seul.
              </div>
            ) : arbre.favoris.map((p) => (
              <div key={p.id} onClick={() => onOuvrir(p.slug)}
                style={{ padding: "7px 0", borderBottom: `1px solid ${THEME.border}`,
                         cursor: "pointer", fontSize: 13, color: THEME.text }}>
                {wCat(p.categorie).icone} {p.titre}
                <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 2 }}>
                  {wCat(p.categorie).rayon_label} › {wCat(p.categorie).label}
                </div>
              </div>
            ))}
          </div>
          </div>

          {/* PIED_RECENTES — une ligne, un filet, pas deux pavés. */}
          <div style={{ borderTop: `1px solid ${THEME.border}`, paddingTop: 12, marginTop: 2 }}>
            {arbre.recentes.length === 0 ? (
              <span style={{ color: THEME.textDim, fontSize: 12.5 }}>
                Le wiki est encore vide — à toi de l'ouvrir.
              </span>
            ) : (
              <div style={{ display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
                <span style={wLbl}>🕒 Modifiées récemment</span>
                {arbre.recentes.slice(0, 6).map((p, i) => (
                  <span key={p.id} style={{ fontSize: 12.5 }}>
                    {i > 0 && <span style={{ color: THEME.border, marginRight: 10 }}>·</span>}
                    <span onClick={() => onOuvrir(p.slug)}
                      style={{ color: THEME.text, cursor: "pointer" }}>
                      {wCat(p.categorie).icone} {p.titre}
                    </span>
                    {p.statut === "brouillon" && (
                      <span style={{ color: THEME.amber, fontSize: 11 }}> · brouillon</span>
                    )}
                    <span style={{ color: THEME.textDim, fontSize: 11 }}>
                      {" "}{new Date(p.updated_at).toLocaleDateString("fr")}
                    </span>
                  </span>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
